<template>
  <v-app>
    <v-main>
      <NuxtPage class="bg-bgprimary" />
      <EmCookieScript />
    </v-main>
  </v-app>
</template>
